import { Component, OnDestroy, ViewChild, AfterViewInit, OnInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { Title, SafeUrl } from '@angular/platform-browser';
import { AuthService } from '../shared/services/auth.service';

import { AlertsService } from '../shared/services/alerts.service';
import { CommonService } from '../shared/services/common.service';
import { LoggedUserClass } from '../shared/models/users-class';
import { CustomerClass, UserMyManagersClass } from '../shared/models/customer-class';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { CustomerService } from '../shared/services/customer.service';
import { ImageService } from '../shared/services/image.service';
import { UploadService } from '../shared/services/upload.service';
import { ClientareaService } from '../shared/services/clientarea.service';
import { GlobalService } from '../shared/services/global.service';
import { BaseService } from '../shared/services/base.service';
import { SeoService } from '../shared/services/seo.service';
import { ProfilePhotoService } from '../shared/services/profile-photo.service';

import { Subject, timer, switchMap, takeUntil } from 'rxjs';
import { Alert } from '../shared/models/alert-class';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { ActiveadminComponent } from '../shared/components/activeadmin/activeadmin.component';
import { FooterComponent } from '../shared/components/footer/footer.component';
import { FullmenuComponent } from '../shared/components/fullmenu/fullmenu.component';
import { UsermenuComponent } from '../shared/components/usermenu/usermenu.component';
import { ConvertImageToUrlPipe } from '../shared/pipes/convert-image-to-url.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';

import { UserAvatarComponent } from '../shared/components/user-avatar/user-avatar.component';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatBadgeModule,
    MatMenuModule,
    MatIconModule,
    MatDividerModule,
    TranslateModule,
    ActiveadminComponent,
    FooterComponent,
    FullmenuComponent,
    UsermenuComponent,
    ConvertImageToUrlPipe,
    MatTooltipModule,
    UserAvatarComponent,
  ],
})
export class PagesComponent implements AfterViewInit, OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild('options') public options: MatDrawer;
  @ViewChild('backToTop') backToTop: any;
  useMyManagersClass: UserMyManagersClass[];
  isHome = false;
  allAlerts: Alert[] = [];
  // Propriedade cacheada — evita NG0100 causado pelo getter ler arrays
  // enquanto CheckAllAlerts os reseta sincronamente no início da chamada
  totalAlerts = 0;

  @ViewChild(UsermenuComponent) public usermenuComponent: UsermenuComponent;
  @ViewChild('headerPhotoMenuTrigger') headerPhotoMenuTrigger: MatMenuTrigger;
  @ViewChild('headerPhotoFileInput') headerPhotoFileInput: ElementRef<HTMLInputElement>;
  headerContextMenuPosition = { x: '0px', y: '0px' };

  get isUserLoggedIn(): boolean {
    return this.authService.isLoggedin(this.globalService.loggedUserClass);
  }

  get hasHeaderProfilePhoto(): boolean {
    const cust = this.globalService.loggedUserClass?.customerClass;
    const comm = this.globalService.loggedUserClass?.commercialClass;
    return !!(cust?.Photo || (cust?.PhotoPath && cust.PhotoPath.trim() !== '') || comm?.Photo);
  }

  get currentHeaderPhotoUrl(): string | SafeUrl | null {
    const cust = this.globalService.loggedUserClass?.customerClass;
    const comm = this.globalService.loggedUserClass?.commercialClass;
    const photo = cust?.Photo || comm?.Photo;
    return photo ? this.imageService.ConvertImageToURL(photo) : null;
  }

  onHeaderAvatarContextMenu(event: MouseEvent): void {
    event.preventDefault();
    this.headerContextMenuPosition.x = `${event.clientX}px`;
    this.headerContextMenuPosition.y = `${event.clientY}px`;
    if (this.headerPhotoMenuTrigger) {
      this.headerPhotoMenuTrigger.openMenu();
    }
  }

  onHeaderPhotoFileSelected(event: Event): void {
    if (this.usermenuComponent) {
      this.usermenuComponent.onPhotoFileSelected(event);
    }
  }

  onHeaderTakePicture(): void {
    if (this.usermenuComponent) {
      this.usermenuComponent.onTakePicture();
    } else {
      this.toggleUserMenu();
    }
  }

  onHeaderViewPhoto(): void {
    if (this.usermenuComponent) {
      this.usermenuComponent.onViewPhoto();
    } else {
      const name =
        this.globalService.loggedUserClass?.customerClass?.firstLastName ||
        this.globalService.loggedUserClass?.customerClass?.Name ||
        this.globalService.loggedUserClass?.commercialClass?.Name ||
        '';
      const url = this.currentHeaderPhotoUrl;
      if (url) {
        this.profilePhotoService.openPhotoView(url, name);
      }
    }
  }

  onHeaderRemovePhoto(): void {
    if (this.usermenuComponent) {
      this.usermenuComponent.onRemovePhoto();
    }
  }

  get userDefaultImage(): any {
    return this.imageService.criarImagemClienteDefault(
      '#dcdcdc',
      this.globalService.loggedUserClass?.customerClass?.Name,
      '#1b1464',
      55,
    );
  }
  constructor(
    public globalService: GlobalService,
    // public appSettings: AppSettings,
    public router: Router,
    public authService: AuthService,
    public alertsService: AlertsService,
    public clientareaService: ClientareaService,
    private commonService: CommonService,
    private customerService: CustomerService,
    public imageService: ImageService,
    private uploadService: UploadService,
    public dialog: MatDialog,
    private baseService: BaseService,

    private titleService: Title,
    private cdr: ChangeDetectorRef,
    private seoService: SeoService,
    public profilePhotoService: ProfilePhotoService,
  ) {
    this.globalService.FullMenu = false;
    // this.settings = this.appSettings.settings;
    this.globalService.EnableDevelopermode = false;

    // + no constructor (depois de this.globalService.EnableDevelopermode = false;)
    const currentPath = this.router.url.split('?')[0].split('#')[0];
    this.isHome = currentPath === '/' || currentPath.startsWith('/home');

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(e => {
      if (e instanceof NavigationEnd) {
        const pathAfterRedirects = e.urlAfterRedirects.split('?')[0].split('#')[0];
        this.isHome = pathAfterRedirects === '/' || pathAfterRedirects.startsWith('/home');
        this.cdr.detectChanges();
      }
    });

    if (!this.authService.isLoggedin(this.globalService.loggedUserClass)) {
      this.globalService.loggedUserClass = new LoggedUserClass();
      this.globalService.loggedUserClass.hasError = false;
      this.globalService.loggedUserClass.statusCode = null;
      this.globalService.loggedUserClass.statusText = '';
      this.globalService.loggedUserClass.userMessage = '';
      this.globalService.loggedUserClass.developerMessage = '';
      this.globalService.loggedUserClass.errorDetails = '';
      this.globalService.loggedUserClass.errorUrl = '';
      this.globalService.loggedUserClass.Token = '';

      this.globalService.loggedUserClass.customerClass = new CustomerClass();
    }
  }

  ngOnInit() {
    // 🔍 SEO: Aplicar noindex apenas nas áreas privadas, restaurar index nas públicas
    this.applyRobotsTag(this.router.url);
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.applyRobotsTag(e.urlAfterRedirects);
      }
    });

    // Carregar foto de perfil ao iniciar (para mostrar no topo da página)
    this.globalService.isRestoringSession$.pipe(takeUntil(this.destroy$)).subscribe(isRestoring => {
      if (!isRestoring) {
        this.loadProfilePhoto();
      }
      this.cdr.detectChanges();
    });

    // Garantir consistência quando há login com sucesso
    this.globalService.loginSuccess$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.cdr.detectChanges();
    });

    // Poll for alerts every 15 minutes
    timer(1000, 15 * 60 * 1000)
      .pipe(
        takeUntil(this.destroy$),
        switchMap(() => {
          if (
            this.authService.isLoggedin(this.globalService.loggedUserClass) &&
            this.globalService.loggedUserClass?.customerClass?.idCustomer
          ) {
            return this.clientareaService.CheckAllAlerts(this.globalService.loggedUserClass.customerClass);
          }
          return [];
        }),
      )
      .subscribe((alerts: Alert[]) => {
        if (alerts) {
          // setTimeout garante que a mutação de totalAlerts não ocorre
          // no mesmo ciclo de CD que leu o valor anterior (evita NG0100)
          setTimeout(() => {
            this.allAlerts = alerts;
            // Aplica os mesmos filtros da alertspage — o badge só conta
            // alertas que são efectivamente mostrados ao utilizador
            const EXCLUIDOS = [
              /não foi assinada/i,
              /não tem morada/i,
              /morada ou está incompleta/i,
              /data fim da apólice.*não pode ser inferior/i,
            ];
            this.totalAlerts = alerts.filter(a => !EXCLUIDOS.some(re => re.test(a.message || ''))).length;
            this.updateBrowserTitle();
            this.cdr.detectChanges();
          });
        }
      });
  }

  private lastLoadedPhotoPath: string | null = null;

  /**
   * Carrega a foto de perfil do utilizador para mostrar no topo da página
   */
  private loadProfilePhoto(): void {
    if (!this.authService.isLoggedin(this.globalService.loggedUserClass)) return;

    const photoPath = this.globalService.loggedUserClass?.customerClass?.PhotoPath;
    if (!photoPath || photoPath.trim() === '') {
      if (this.globalService.loggedUserClass?.customerClass) {
        this.globalService.loggedUserClass.customerClass.Photo = null;
      }
      this.lastLoadedPhotoPath = null;
      this.cdr.detectChanges();
      return;
    }

    // Se já tem esta foto específica carregada, forçar detecção de alterações
    const existingPhoto = this.globalService.loggedUserClass?.customerClass?.Photo;
    if (existingPhoto && this.lastLoadedPhotoPath === photoPath) {
      this.cdr.detectChanges();
      return;
    }

    this.uploadService
      .download(photoPath)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async (file: File) => {
          if (file && this.globalService.loggedUserClass?.customerClass) {
            this.globalService.loggedUserClass.customerClass.Photo = await this.imageService.FileToBuffer(file);
            this.lastLoadedPhotoPath = photoPath;
            this.globalService.profilePhotoLoaded$.next(true);
            this.cdr.detectChanges();
          }
        },
      });
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngAfterViewInit() {
    this.globalService.options = this.options;
    // setTimeout(() => { this.settings.loadingSpinner = false; }, 300);
    this.cdr.detectChanges();
  }

  public scrollToTop() {
    this.baseService.scrollToTop();
  }

  public onPsScrollY(event) {
    event.target.scrollTop > 300
      ? (this.backToTop.nativeElement.style.display = 'flex')
      : (this.backToTop.nativeElement.style.display = 'none');
  }

  async changedPhoto(_photo) {
    if (this.globalService?.loggedUserClass?.customerClass?.PhotoPath) {
      const currentPath = this.globalService.loggedUserClass.customerClass.PhotoPath;
      if (currentPath?.trim() !== '') {
        await this.uploadService
          .download(currentPath)
          .pipe(takeUntil(this.destroy$))
          .subscribe(async (file: File) => {
            if (file && this.globalService.loggedUserClass?.customerClass) {
              this.globalService.loggedUserClass.customerClass.Photo = await this.imageService.FileToBuffer(file);
              this.lastLoadedPhotoPath = currentPath;
              this.authService.saveSession(this.globalService.loggedUserClass);
              this.globalService.profilePhotoLoaded$.next(true);
              this.cdr.detectChanges(); // Garante atualização visual após upload
            }
          });
      }
    }

    if (this.globalService?.loggedUserClass) {
      this.commonService
        .SetSiteRoutesLog(
          this.globalService.loggedUserClass.idUser,
          'Cliente / Gestor',
          'Alterar foto',
          this.globalService.loggedUserClass.UUID,
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          error: error => console.log(error),
        });
    }
  }

  showAlert() {
    // Reconstruct the list from the source of truth (GlobalService) to ensure it matches the badge
    const cust = this.globalService.loggedUserClass?.customerClass;
    let currentAlerts: Alert[] = [];

    if (cust) {
      if (cust.alertUser) currentAlerts = [...currentAlerts, ...cust.alertUser];
      if (cust.alertClientAreaInsurances) currentAlerts = [...currentAlerts, ...cust.alertClientAreaInsurances];
      if (cust.alertClientAreaInsurancesClaims)
        currentAlerts = [...currentAlerts, ...cust.alertClientAreaInsurancesClaims];
      if (cust.alertClientAreaSafeSimulations)
        currentAlerts = [...currentAlerts, ...cust.alertClientAreaSafeSimulations];
    }

    // Fallback to allAlerts if global service is somehow empty but polling worked (unlikely but safe)
    if (currentAlerts.length === 0 && this.allAlerts.length > 0) {
      currentAlerts = this.allAlerts;
    }

    this.alertsService.showAlerts(currentAlerts, '');
  }

  /** Navega diretamente para a página de alertas */
  navigateToAlerts(): void {
    this.globalService.FullMenu = false;
    this.router.navigate(['/clientarea/alertas']);
  }

  toggleUserMenu() {
    if (this.authService.isLoggedin(this.globalService.loggedUserClass)) {
      this.scrollToTop();

      const nif = this.globalService.loggedUserClass?.customerClass?.NIF || this.globalService.loggedUserClass?.NIF;
      if (nif) {
        this.customerService
          .ClientAreaGetCustomerNIF(nif)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (customer: any) => {
              if (!this.globalService.loggedUserClass) return;
              const customerData = Array.isArray(customer) ? customer[0] : customer;
              if (customerData) {
                // Garantir que temos uma instância de CustomerClass
                if (!(this.globalService.loggedUserClass.customerClass instanceof CustomerClass)) {
                  this.globalService.loggedUserClass.customerClass = Object.assign(
                    new CustomerClass(),
                    this.globalService.loggedUserClass.customerClass,
                  );
                }

                // Guardar foto antes da sobreposição (a API não devolve o blob Photo)
                const previousPhoto = this.globalService.loggedUserClass.customerClass.Photo;
                const previousPhotoPath = this.globalService.loggedUserClass.customerClass.PhotoPath;
                Object.assign(this.globalService.loggedUserClass.customerClass, customerData);
                // Restaurar foto se o path não mudou e a API não trouxe blob
                if (previousPhoto && !this.globalService.loggedUserClass.customerClass.Photo) {
                  if (
                    !this.globalService.loggedUserClass.customerClass.PhotoPath ||
                    this.globalService.loggedUserClass.customerClass.PhotoPath === previousPhotoPath
                  ) {
                    this.globalService.loggedUserClass.customerClass.Photo = previousPhoto;
                  }
                }
                this.globalService.loggedUserClass.customerClass.parseDates();
                this.cdr.detectChanges();
              }
            },
            error: error => console.log(error),
            complete: async () => {
              if (!this.globalService.loggedUserClass?.customerClass) return;
              if (this.globalService.loggedUserClass?.customerClass?.PhotoPath) {
                if (this.globalService.loggedUserClass.customerClass?.PhotoPath?.trim() !== '') {
                  this.uploadService
                    .download(this.globalService.loggedUserClass.customerClass.PhotoPath)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe({
                      next: async (file: File) => {
                        if (file && this.globalService.loggedUserClass?.customerClass) {
                          this.globalService.loggedUserClass.customerClass.Photo =
                            await this.imageService.FileToBuffer(file);
                          this.cdr.detectChanges();
                        }
                      },
                    });
                }
              }

              this.useMyManagersClass = JSON.parse(
                JSON.stringify(this.globalService.loggedUserClass?.customerClass?.MyManager || '[]'),
              );
              this.baseService.onChangeName(
                this.globalService.loggedUserClass?.customerClass?.Name || '',
                this.globalService.loggedUserClass?.customerClass?.NIF || '',
              );
              if (this.globalService.loggedUserClass?.customerClass?.idCustomer) {
                this.clientareaService.ClientAreaGetCustomerShipToAddress(
                  this.globalService.loggedUserClass.customerClass.idCustomer,
                );
              }

              // Refreshes client specific data (User alerts) when opening menu
              if (this.options.opened && this.globalService.loggedUserClass?.customerClass) {
                this.clientareaService.CheckDataclient(this.globalService.loggedUserClass.customerClass);
              }

              // Atualizar título do browser após carregar todos os dados (incluindo foto)
              this.updateBrowserTitle();
            },
          });
      }
      this.options.toggle();
    }
  }

  ClienteArea() {
    this.router.navigate(['/ClientArea'], { skipLocationChange: false });
  }

  openFullMenu() {
    this.scrollToTop();
    this.globalService.FullMenu = !this.globalService.FullMenu;
  }

  /**
   * Atualiza o título do browser com o número de alertas
   */
  private updateBrowserTitle(): void {
    // Contador retirado do título (pedido do user) - Mantém apenas o nome base
    const baseTitle = 'Seguros Virtual';
    this.titleService.setTitle(baseTitle);
  }

  /**
   * 🔍 SEO: Apenas as rotas do sitemap.xml devem ser indexadas.
   * Rotas indexáveis: / (home) e /seguros/* (produtos)
   * Tudo o resto → noindex, nofollow
   */
  private applyRobotsTag(url: string): void {
    const path = url.split('?')[0].split('#')[0]; // Remover query params e fragments

    // Apenas a homepage e as páginas de seguros (presentes no sitemap.xml) devem ser indexadas
    const isIndexable = path === '/' || path === '' || path.startsWith('/seguros');

    if (isIndexable) {
      this.seoService.setIndex();
    } else {
      this.seoService.setNoIndex();
    }
  }

  ngOnDestroy(): void {
    if (!this.destroy$.closed) {
      // Verificação adicionada
      this.destroy$.next();
      this.destroy$.complete();
    }
  }
}
